import React from 'react';
import ReactDOM from 'react-dom/client';
import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday';
import localeData from 'dayjs/plugin/localeData';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekYear from 'dayjs/plugin/weekYear';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import App from './App';
import './index.css';
import './styles/dark-theme-overrides.css';
import './lib/i18n';

// antd yêu cầu BẮT BUỘC các plugin dayjs này khi dùng DatePicker/generatePicker với `ConfigProvider
// locale` khác mặc định (xem App.tsx, locale={viVN}/{enUS}) — thiếu thì antd tự gọi các hàm như
// `dayjs().weekday()` lúc render lịch/điều hướng ngày và crash ngay khi tương tác (bug thật gặp ở
// DatePicker của court BookingsPage, nhưng đây là lỗi cấu hình TOÀN APP, không riêng 1 trang — trước đây
// chỉ import rải rác `dayjs/locale/vi` ở từng file, KHÔNG đủ, phải extend plugin 1 lần duy nhất ở đây,
// trước khi App render, để áp dụng cho MỌI DatePicker/RangePicker/TimePicker trong toàn bộ app.
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);
dayjs.extend(quarterOfYear);
dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// StrictMode disabled for react-beautiful-dnd compatibility with React 18
// react-beautiful-dnd v13 has issues with StrictMode double rendering
root.render(<App />);